import {
  Badge,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Skeleton,
  Switch,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure
} from '@chakra-ui/react'
import { useState } from 'react'
import { FiEdit } from 'react-icons/fi'
import { NotFound } from '../../../components/molecules/NotFound'
import {
  useEquipmentGroupMutations,
  useEquipmentGroups
} from '../../../hooks/equipmentGroups/useEquipmentGroups'
import { LayoutList } from '../../../layouts/List'
import { EquipmentGroup } from '../../../types/equipment'

export function EquipmentGroups() {
  const modal = useDisclosure()
  const [editing, setEditing] = useState<EquipmentGroup | null>(null)
  const [name, setName] = useState('')
  const [isActive, setIsActive] = useState(true)
  const { data, isLoading, isFetching, refetch } = useEquipmentGroups()
  const mutations = useEquipmentGroupMutations()
  const open = (group?: EquipmentGroup) => {
    setEditing(group || null)
    setName(group?.name || '')
    setIsActive(group?.is_active !== false)
    modal.onOpen()
  }
  const save = async () => {
    if (!name.trim()) return
    if (editing)
      await mutations.update.mutateAsync({ id: editing.id, name: name.trim(), is_active: isActive })
    else await mutations.create.mutateAsync({ name: name.trim(), is_active: isActive })
    modal.onClose()
  }
  return (
    <LayoutList
      title="Grupos de equipamentos"
      urlNew="#"
      refetch={refetch}
      isFetching={isFetching}
      capturaChange={() => {}}
      captureActiveChange={() => {}}
      spiCode="CUSTOMER_TAGS"
      isHaveFilter={false}
      isViewActive={false}
      isButtonNew={false}
      isSearched={false}
    >
      <Flex w="100%" justifyContent="flex-end">
        <Button w="320px" mb="4" colorScheme="blue" onClick={() => open()}>
          Novo grupo
        </Button>
      </Flex>
      <Box overflowX="auto">
        <Table variant="striped" colorScheme="blue" size="sm">
          <Thead>
            <Tr>
              <Th>Nome do grupo</Th>
              <Th>Status</Th>
              <Th>Ações</Th>
            </Tr>
          </Thead>
          <Tbody>
            {isLoading
              ? [1, 2, 3].map((i) => (
                  <Tr key={i}>
                    <Td colSpan={3}>
                      <Skeleton height="20px" />
                    </Td>
                  </Tr>
                ))
              : data?.groups.map((group) => (
                  <Tr key={group.id}>
                    <Td>
                      <Text>{group.name}</Text>
                    </Td>
                    <Td>
                      <Badge colorScheme={group.is_active === false ? 'gray' : 'green'}>
                        {group.is_active === false ? 'Inativo' : 'Ativo'}
                      </Badge>
                    </Td>
                    <Td>
                      <Button
                        aria-label="Editar grupo"
                        size="xs"
                        variant="ghost"
                        onClick={() => open(group)}
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        ml="2"
                        size="xs"
                        variant="outline"
                        onClick={() => mutations.remove.mutate(group)}
                      >
                        {group.is_active === false ? 'Ativar' : 'Desativar'}
                      </Button>
                    </Td>
                  </Tr>
                ))}
          </Tbody>
        </Table>
        {!isLoading && !data?.groups.length && <NotFound />}
      </Box>
      <Modal isOpen={modal.isOpen} onClose={modal.onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{editing ? 'Editar grupo' : 'Novo grupo'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isRequired>
              <FormLabel>Nome do grupo</FormLabel>
              <Input value={name} onChange={(e) => setName(e.target.value)} />
            </FormControl>
            <FormControl mt="4" display="flex" alignItems="center">
              <FormLabel mb="0">Ativo</FormLabel>
              <Switch isChecked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={modal.onClose}>
              Cancelar
            </Button>
            <Button
              ml="3"
              colorScheme="blue"
              isDisabled={!name.trim()}
              isLoading={mutations.create.isLoading || mutations.update.isLoading}
              onClick={save}
            >
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </LayoutList>
  )
}
